export default function MicrositeErrorPage() {
  return (
    <div className="max-w-screen-sm mx-auto p-4">
      <h1 className="text-xl font-semibold mb-2">Link expired or invalid</h1>
      <p className="text-sm text-gray-700">
        Your access link is invalid or has expired. You can request a new link
        from your golf professional.
      </p>
    </div>
  );
}
